import gql from 'graphql-tag';

export const GET_CS_TEMPLATES_AND_STAGES = gql`
  query CSTemplatesAndStages($dynamicsId: ID, $creditSubmissionId: ID) {
    result: creditSubmission(dynamicsId: $dynamicsId, creditSubmissionId: $creditSubmissionId) {
      businessProcessFlows {
        flows {
          currentStage
          businessProcessFlowId
        }
      }
    }
  }
`;
